import { useDataTypesHooks } from "../../../features/data-types"
import { usePurchaseLoaders } from "../../purchases"
import { useBudgetLoaders, useSaleOperationLoaders } from "../../sales"
import { useExpenseLoaders } from "../loaders/expenseLoaders"
import { Employee } from "../state/types"

export const useEmployeeHooks = () => {
    const { formatIdentifier } = useDataTypesHooks()

    const expenseLoaders = useExpenseLoaders()
    const purchaseLoaders = usePurchaseLoaders()
    const budgetLoaders = useBudgetLoaders()
    const saleOperationLoaders = useSaleOperationLoaders()

    const describeEmployee = (employee: Employee): string => {
        return employee.name + (employee.identifier ? ` (${formatIdentifier(employee.identifier)})` : '')
    }

    const canRemoveEmployee = async (employeeId: string): Promise<boolean> => {
        const { countExpenses } = expenseLoaders()
        const expensesCount = await countExpenses('employeeId', employeeId)

        const { countPurchases } = purchaseLoaders()
        const purchasesCount = await countPurchases('employeeId', employeeId)

        const { countBudgets } = budgetLoaders()
        const budgetsCount = await countBudgets('sellerId', employeeId)

        const { countSaleOperations } = saleOperationLoaders()
        const saleOperationsCount = await countSaleOperations('sellerId', employeeId)

        return expensesCount === 0 &&
            purchasesCount === 0 &&
            budgetsCount === 0 &&
            saleOperationsCount === 0
    }

    return {
        describeEmployee,
        canRemoveEmployee
    }
}
